<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "Average EV Efficiency" chart.
    </rb-callout>
</div>
<div id="average-ev-efficiency-chart"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container ">
        Distribution of the efficiencies <span>(in {{ getEfficiencyAxisLabel() }})</span> observed for the vehicles within your fleet along with the corresponding value(s) of the selected vehicle(s). The values are given as a percentage of the whole fleet.
    </div>
</div>